/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/ip_addresses" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationIpAddressesCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSenderVerificationIpAddressesProps,
  CompaniesCompanyIdSenderVerificationCreateIpAddressesResult,
} from "./types";

export const postCompaniesCompanyIdSenderVerificationIpAddresses = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationIpAddressesCacheKeys,
  (
    props: PostCompaniesCompanyIdSenderVerificationIpAddressesProps
  ): Promise<CompaniesCompanyIdSenderVerificationCreateIpAddressesResult> => {
    return fetch(
      `/companies/${props.companyId}/sender_verification/ip_addresses`,
      "POST",
      {
        company_id: props.companyId,
        ip_pool_id: props.ipPoolId,
        number_of_ips: 1,
        domain: props.domain,
      },
      {},
      { propagateFetchRequestError: false }
    );
  }
);
